import React from 'react';
import styles from './style.module.css';
import StepOneForm from '../../components/forms/step-one';
import InfoBox from '../../../../common/components/info-box';

const tooltip = {
    title: 'What is prosperity?',
    content: <span>Prosperity means different things to different people. To some, prosperity means: <strong>Success, Wealth, Comfort</strong> or <strong>Security</strong>.</span>
};

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>My Prosperity Planner</p>
        <h1 className={styles.mainTitle}>Prosperity</h1>
        <p className={styles.text}>The journey to prosperity can be simple and fun. Set priorities, plan small steps and remember to enjoy lots of sunshine along the way.</p>
        <StepOneForm />
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
        />
    </div>
);
